// IntersectionObserver for ".mutant" elements
(function () {
    const check = (entries) => entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
            entry.target.classList.add("mutated");
        } else {
            entry.target.classList.remove("mutated");
        }
    });

    const Obs = new IntersectionObserver(check);
    document.querySelectorAll(".mutant").forEach(el => Obs.observe(el));
})();







// IntersectionObserver for ".enchanter" elements
(function () {
    const enchanters = document.querySelectorAll(".enchanter");
    const observer = new IntersectionObserver(
        entries => {
            entries.forEach(entry => {
                entry.target.classList.toggle("enchanted", entry.isIntersecting);
            });
        },
        {
            threshold: 0.6,
        }
    );

    enchanters.forEach(enchanter => {
        observer.observe(enchanter);
    });
})();